
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class TaxDetailsDialog extends Serenity.EntityDialog<TaxDetailsRow, any> {
        protected getFormKey() { return TaxDetailsForm.formKey; }
        protected getIdProperty() { return TaxDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return TaxDetailsRow.localTextPrefix; }
        protected getNameProperty() { return TaxDetailsRow.nameProperty; }
        protected getService() { return TaxDetailsService.baseUrl; }
        protected getDeletePermission() { return TaxDetailsRow.deletePermission; }
        protected getInsertPermission() { return TaxDetailsRow.insertPermission; }
        protected getUpdatePermission() { return TaxDetailsRow.updatePermission; }

        protected form = new TaxDetailsForm(this.idPrefix);
        
    }
}